import { render, staticRenderFns } from "./PageBackBtn.vue?vue&type=template&id=f3e58644&scoped=true"
import script from "./PageBackBtn.vue?vue&type=script&lang=js"
export * from "./PageBackBtn.vue?vue&type=script&lang=js"
import style0 from "./PageBackBtn.vue?vue&type=style&index=0&id=f3e58644&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e58644",
  null
  
)

export default component.exports